<h2 mat-dialog-title>{{ 'assignment.reset_to_phase_one.confirmation.title' | transloco }}</h2>
<mat-dialog-content>
	@if (status() === 'checking' || status() === 'ready') {
		<p>{{ 'assignment.reset_to_phase_one.confirmation.message' | transloco }}</p>
	}
	<div class="verification" role="status" aria-live="polite">
		@if (status() === 'checking') {
			<mat-spinner diameter="24" aria-hidden="true"></mat-spinner>
			<span>{{ 'assignment.reset_to_phase_one.confirmation.checking' | transloco }}</span>
		} @else if (status() === 'ready') {
			<strong>{{ 'assignment.reset_to_phase_one.confirmation.success' | transloco }}</strong>
		} @else {
			<div>
				<strong>{{ 'assignment.reset_to_phase_one.confirmation.failed' | transloco }}</strong>
				@if (reasons().length > 0) {
					<ul>
						@for (reason of reasons(); track $index) {
							<li>{{ reasonText(reason.code, reason.message) }}</li>
						}
					</ul>
				} @else {
					<p>{{ 'assignment.reset_to_phase_one.error' | transloco }}</p>
				}
			</div>
		}
	</div>
</mat-dialog-content>
<mat-dialog-actions class="actions-row">
	<lvr-button
		variant="secondary"
		[label]="'assignment.reset_to_phase_one.confirmation.cancel' | transloco"
		(clicked)="cancel()"
	></lvr-button>
	<lvr-button
		variant="primary"
		[label]="'assignment.reset_to_phase_one.confirmation.confirm' | transloco"
		[disabled]="status() !== 'ready'"
		(clicked)="confirm()"
	></lvr-button>
</mat-dialog-actions>
